module.exports = __webpack_public_path__ + "static/media/g3.b746ab2f.png";